import AsyncStorage from "@react-native-async-storage/async-storage";

export const cacheItem = async (key, value) => {
  AsyncStorage.setItem(key, value);
};

export const getCachedItem = async (key) => {
  return AsyncStorage.getItem(key);
};

export const removeCachedItem = async (key) => AsyncStorage.removeItem(key);
